import React, {
  useState,
  useEffect,
  useRef,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { fetchCustomerDetails } from "../../redux/slice/customerDetails";

import { resetEarnedAndRedeemedPoints } from "../../redux/slice/earnedPoints";
import { formatIndianNumber } from "../../utils/common";

import "./DlfProgram.scss";
import PointHistory from "../pointHistory/PointHistory";
import Spinner from "../../component/spinner/Spinner";
import exclusiveProgramIcon from "../../assets/images/exclusiveProgramIcon.svg";
import silver_milestone from "../../assets/images/silver_rupe_icon.svg";
import gold_milestone from "../../assets/images/gold_milestone.svg";
import platinum_milestone from "../../assets/images/platinum_milestone.svg";
import exclusive_milestone from "../../assets/images/exclusive_milestone.svg";
import gold_rupe_icon from "../../assets/images/gold_rupe_icon-cropped.svg";
import gold_rupe_icon_lg from "../../assets/images/gold_rupe_lg.svg";
import gold_rupe_icon_md from "../../assets/images/gold_rupe_md.svg";
import PlusIcon from "../../assets/images/plusIcon.svg";
import arrow from "../../assets/images/arrow.svg";
import referIcon from "../../assets/images/refer.svg";

import silver_rupeIcon from "../../assets/images/silver_rupeIcon.svg";
import goldProgramIcon from "../../assets/images/goldProgramIcon.svg";
import platinumProgramIcon from "../../assets/images/platinumProgramIcon.svg";
import ConditionalModalInviteFail from "../../component/ConditionalModal/ConditionalModalInviteFail";
// import Failure from "../../component/ConditionalModal/Dynamic";
import ConditionalModalInviteSucess from "../../component/ConditionalModal/ConditionalModalInviteSucess";
import ConditionalModalBillSucess from "../../component/ConditionalModal/ConditionalModalBillSucess";
import MyVerticallyCenteredModal from "../../component/MyVerticallyCenteredModal";

const ExclusiveProgram = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mobile = localStorage.getItem("mobile");
  const [modalShow, setModalShow] = useState(false);
  const [failModalShow, setFailModalShow] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const [successModalShow, setSuccessModalShow] = useState(false);
  const [successModal2Show, setSuccessModal2Show] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const modalRef = useRef();
  const handleResetOutside = () => {
    if (modalRef.current) {
      modalRef.current.handleReset();
    }
  };

  const { customerDetailsData, loading } = useSelector(
    (state) => state.customerDetails
  );
  const expiryData = customerDetailsData?.expiry_schedule?.schedule;

  const earliestExpiry = expiryData?.reduce((earliest, current) => {
    return new Date(current.expiry_date) < new Date(earliest.expiry_date)
      ? current
      : earliest;
  });
  const expiryDate = new Date(earliestExpiry?.expiry_date);
  const formattedDate = expiryDate
    ?.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    })
    ?.replace(/ /g, "’");

  useEffect(() => {
    if (mobile) {
      dispatch(fetchCustomerDetails());
    }
    return () => {
      dispatch(resetEarnedAndRedeemedPoints());
    };
  }, [mobile]);
  // console.log(customerDetailsData, 'customerDetailsData')
  let silverProgressValue = 0;
  let goldProgressValue = 0;
  let platinumProgressValue = 0;

  let currentPoints = Number(
    customerDetailsData?.points_summaries?.points_summary[0]?.gap_to_upgrade
      ?.upgrade_strategy[0]?.customer_upgrade_entity_values?.current_value
  );
  let pointsToUpgrade =
    customerDetailsData?.points_summaries?.points_summary[0]?.gap_to_upgrade
      ?.upgrade_strategy[0]?.customer_upgrade_entity_values?.gap_to_upgrade;
  const currentSlab = customerDetailsData?.current_slab;

  if (!isNaN(currentPoints)) {
    if (currentSlab === "Silver") {
      silverProgressValue = (currentPoints / 100000) * 100;
    } else if (currentSlab === "Gold") {
      goldProgressValue = ((currentPoints - 100000) / 200000) * 100;
      silverProgressValue = 100;
    } else if (currentSlab === "Platinum") {
      silverProgressValue = 100;
      goldProgressValue = 100;
      platinumProgressValue = ((currentPoints - 300000) / 200000) * 100;
    } else {
      silverProgressValue = 100;
      goldProgressValue = 100;
      platinumProgressValue = 100;
    }
  }
  if (
    customerDetailsData?.points_summaries?.points_summary[0]?.gap_to_upgrade
      ?.upgrade_strategy?.length === 0
  ) {
    silverProgressValue = 100;
    goldProgressValue = 100;
    platinumProgressValue = 100;
  }

  return (
    <>
      {loading ? (
        <div className="spinner_table_height">
          <Spinner color="black" />
        </div>
      ) : (
        <div className="milestone_section">
          <div className="aside-box milestone_spacing">
            <div
              className={`milestone ${
                customerDetailsData?.current_slab === "Silver"
                  ? "milestone_card_bg_silver"
                  : customerDetailsData?.current_slab === "Gold"
                  ? "milestone_card_bg_gold"
                  : customerDetailsData?.current_slab === "Platinum"
                  ? "milestone_card_bg_platinum"
                  : "milestone_card_bg_exclusive"
              }`}
            >
              <div
                className={`milestone_details d-flex ${
                  customerDetailsData?.current_slab === "Silver"
                    ? "milestone_details_silver"
                    : customerDetailsData?.current_slab === "Gold"
                    ? "milestone_details_gold"
                    : customerDetailsData?.current_slab === "Platinum"
                    ? "milestone_details_platinum"
                    : "milestone_details_exclusive"
                }`}
              >
                <img
                  className="mob_order-2"
                  src={
                    customerDetailsData?.current_slab === "Silver"
                      ? silver_rupeIcon
                      : customerDetailsData?.current_slab === "Gold"
                      ? goldProgramIcon
                      : customerDetailsData?.current_slab === "Platinum"
                      ? platinumProgramIcon
                      : exclusiveProgramIcon
                  }
                  alt=""
                />
                <div className="mob_order-1 mobile_content mob_useCad">
                  <h1>
                    {customerDetailsData?.firstname}{" "}
                    {customerDetailsData?.lastname}
                  </h1>
                  <p>
                    {customerDetailsData?.current_slab === "Silver"
                      ? "Silver"
                      : customerDetailsData?.current_slab === "Gold"
                      ? "Gold"
                      : customerDetailsData?.current_slab === "Platinum"
                      ? "Platinum"
                      : "Exclusive"}{" "}
                    Member
                  </p>
                </div>
                <div className="milestone_name desktop_content mob_order-1">
                  <p className="desktop_content">
                    Hi {customerDetailsData?.firstname}, You are a
                  </p>
                  <span className="">
                    {customerDetailsData?.current_slab === "Silver"
                      ? "Silver"
                      : customerDetailsData?.current_slab === "Gold"
                      ? "Gold"
                      : customerDetailsData?.current_slab === "Platinum"
                      ? "Platinum"
                      : "Exclusive"}{" "}
                    <button className="member_button">Member</button>
                  </span>
                </div>
              </div>

              {/* Progress bar */}
              <div
                className={`progress-bar ${
                  customerDetailsData?.current_slab === "Silver"
                    ? "progress-bar_silver"
                    : customerDetailsData?.current_slab === "Gold"
                    ? "progress-bar_gold"
                    : customerDetailsData?.current_slab === "Platinum"
                    ? "progress-bar_platinum"
                    : "progress-bar_exclusive"
                }`}
              >
                <div className="step">
                  <img
                    src={silver_milestone}
                    alt="Silver Icon"
                    className="icon"
                  />
                  <h1>SILVER</h1>
                </div>
                <div
                  style={{ position: "relative" }}
                  className="progress-container1"
                >
                  {currentSlab === "Silver" && (
                    <div
                      className="tool"
                      style={{ left: `${silverProgressValue - 11}%` }}
                    >
                      You’re here now
                    </div>
                  )}
                  <progress
                    id="file"
                    value={silverProgressValue}
                    max="100"
                  ></progress>
                </div>
                <div className="step">
                  <img src={gold_milestone} alt="Gold Icon" className="icon" />
                  <h1>GOLD</h1>
                  {currentSlab === "Silver" && (
                    <span>
                      100000
                      <img src={gold_rupe_icon} alt="" style={{marginLeft: "5px"}}/> <br />
                      to upgrade
                    </span>
                  )}
                </div>
                <div
                  style={{ position: "relative" }}
                  className="progress-container1"
                >
                  {currentSlab === "Gold" && (
                    <div
                      className="tool"
                      style={{ left: `${goldProgressValue - 11}%` }}
                    >
                      You’re here now
                    </div>
                  )}
                  <progress
                    id="file"
                    value={goldProgressValue}
                    max="100"
                  ></progress>
                </div>
                <div className="step">
                  <img
                    src={platinum_milestone}
                    alt="Platinum Icon"
                    className="icon"
                  />
                  <h1>PLATINUM</h1>
                  {(currentSlab === "Silver" || currentSlab === "Gold") && (
                    <span>
                      300000
                      <img src={gold_rupe_icon} alt="" style={{marginLeft: "5px"}} /> <br />
                      to upgrade
                    </span>
                  )}
                </div>
                <div
                  style={{ position: "relative" }}
                  className="progress-container1"
                >
                  {currentSlab === "Platinum" && (
                    <div
                      className="tool"
                      style={{ left: `${platinumProgressValue - 11}%` }}
                    >
                      You’re here now
                    </div>
                  )}
                  {currentSlab === "Exclusive" && (
                    <div className="tool tool1">You made it!</div>
                  )}
                  <progress
                    id="file"
                    value={platinumProgressValue}
                    max="100"
                  ></progress>
                </div>
                <div className="step">
                  <img
                    src={exclusive_milestone}
                    alt="Exclusive Icon"
                    className="icon"
                  />
                  <h1>EXCLUSIVE</h1>
                  {(currentSlab === "Silver" ||
                    currentSlab === "Gold" ||
                    currentSlab === "Platinum") && (
                    <span>
                      500000
                      <img src={gold_rupe_icon} alt="" style={{marginLeft: "5px"}} /> <br />
                      to upgrade
                    </span>
                  )}
                </div>
              </div>
              <div
                className={`current_milestone ${
                  customerDetailsData?.current_slab === "Silver"
                    ? "mob_silver"
                    : customerDetailsData?.current_slab === "Gold"
                    ? "mob_gold"
                    : customerDetailsData?.current_slab === "Platinum"
                    ? "mob_platinum"
                    : "mob_exclusive"
                }`}
              >
                {currentSlab !== "Exclusive" && (
                  <p className="border-bottom desktop_content">
                    Amount needed to upgrade to{" "}
                    {customerDetailsData?.current_slab === "Silver"
                      ? "Gold"
                      : customerDetailsData?.current_slab === "Gold"
                      ? "Platinum"
                      : customerDetailsData?.current_slab === "Platinum"
                      ? "Exclusive"
                      : ""}{" "}
                    : <span className="high_light_text">{formatIndianNumber(pointsToUpgrade)}</span>
                    <img className="rupe_gold" src={gold_rupe_icon} alt="" />
                  </p>
                )}
                <div className="d-flex justify-content-between bill_button_section">
                  <div>
                    <p className="desktop_content">Points Balance</p>
                    <p className="points">
                      {formatIndianNumber(
                        customerDetailsData?.points_summaries?.points_summary[0]
                          ?.total_available_points
                      )}
                      <img src={gold_rupe_icon_lg} alt="" />
                    </p>
                  </div>
                  <div className="button_container ">
                    <div className="d-flex">
                      <button
                        className="radius0_button addBill desktop_content"
                        onClick={() => setModalShow(true)}
                      >
                        <img src={PlusIcon} alt="" /> ADD BILL
                      </button>
                      <MyVerticallyCenteredModal
                        ref={modalRef}
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                        setModalShow={setModalShow}
                        setFailModalShow={setFailModalShow}
                        setFailMessage={setFailMessage}
                        setSuccessModalShow={setSuccessModalShow}
                        setSuccessModal2Show={setSuccessModal2Show}
                        setSuccessMessage={setSuccessMessage}
                      />
                      <button
                        className={`radius0_button reddemPoint ${
                          customerDetailsData?.current_slab === "Silver"
                            ? "reddemPoint_silver"
                            : customerDetailsData?.current_slab === "Gold"
                            ? "reddemPoint_gold"
                            : customerDetailsData?.current_slab === "Platinum"
                            ? "reddemPoint_platinum"
                            : "reddemPoint_exclusive"
                        }`}
                      >
                        <Link to="/rewards-catalogue">
                          Redeem Points <img src={arrow} alt="arrow icon" />
                        </Link>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {!isNaN(Math.floor(earliestExpiry?.points)) && (
              <div className="expire_sec">
                <p>
                  <img
                    src={gold_rupe_icon_md}
                    className="flootOnlyTab"
                    alt=""
                  />{" "}
                  Hurry up! Your{" "}
                  <span className="high_light_text">
                    {isNaN(parseFloat(earliestExpiry?.points))
                      ? "0.00"
                      : formatIndianNumber(earliestExpiry?.points)}{" "}
                    Points
                  </span>{" "}
                  are gonna expire on{" "}
                  {formattedDate === "Invalid’Date"
                    ? "30'Sept'25"
                    : formattedDate}
                  . Use them before you loose them!
                </p>
              </div>
            )}
            {/* <div
              className="expire_sec transferPoint d-flex desktop_content"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/friends-family")}
            >
              <div>
                <img src={referIcon} alt="" />
              </div>
              <div>
                <h1>Transfer Points to Friends & Family</h1>
                <p>
                  Why keep all the rewards to yourself? Share the love (and the
                  points) with your friends and family!
                </p>
              </div>
            </div> */}
            <div
              className={`progress-bar-mob ${
                customerDetailsData?.current_slab === "Silver"
                  ? "progress-bar-mob_silver"
                  : customerDetailsData?.current_slab === "Gold"
                  ? "progress-bar-mob_gold"
                  : customerDetailsData?.current_slab === "Platinum"
                  ? "progress-bar-mob_platinum"
                  : "progress-bar-mob_exclusive"
              } mobile_content`}
            >
              <div className="step">
                <img
                  src={silver_milestone}
                  alt="Silver Icon"
                  className="icon"
                />
                <h1>SILVER</h1>
              </div>
              <div
                style={{ position: "relative" }}
                className="progress-container1"
              >
                {currentSlab === "Silver" && (
                  <div
                    className="tool"
                    style={{ left: `${silverProgressValue - 40}%` }}
                  >
                    You’re here now
                  </div>
                )}
                <progress
                  id="file"
                  value={silverProgressValue}
                  max="100"
                ></progress>
              </div>
              <div className="step">
                <img src={gold_milestone} alt="Gold Icon" className="icon" />
                <h1>GOLD </h1>
                <span>
                  <p>
                    100000
                    <img src={gold_rupe_icon} alt="" style={{marginLeft: "4px"}}/>
                  </p>
                  <p>to upgrade</p>
                </span>
              </div>
              <div
                style={{ position: "relative" }}
                className="progress-container1"
              >
                {currentSlab === "Gold" && (
                  <div
                    className="tool"
                    style={{ left: `${goldProgressValue - 40}%` }}
                  >
                    You’re here now
                  </div>
                )}
                <progress
                  id="file"
                  value={goldProgressValue}
                  max="100"
                ></progress>
              </div>
              <div className="step">
                <img
                  src={platinum_milestone}
                  alt="Platinum Icon"
                  className="icon"
                />
                <h1>PLATINUM</h1>
                <span>
                  <p>
                    300000
                    <img src={gold_rupe_icon} alt="" style={{marginLeft: "4px"}}/>{" "}
                  </p>
                  <p> to upgrade</p>
                </span>
              </div>
              <div
                style={{ position: "relative" }}
                className="progress-container1"
              >
                {currentSlab === "Platinum" && (
                  <div
                    className="tool"
                    style={{ left: `${platinumProgressValue - 40}%` }}
                  >
                    You’re here now
                  </div>
                )}
                {currentSlab === "Exclusive" && (
                  <div className="tool tool1">You made it!</div>
                )}
                <progress
                  id="file"
                  value={platinumProgressValue}
                  max="100"
                ></progress>
              </div>
              <div className="step">
                <img
                  src={exclusive_milestone}
                  alt="Exclusive Icon"
                  className="icon"
                />
                <h1>EXCLUSIVE</h1>
                <span>
                  <p>
                    500000
                    <img src={gold_rupe_icon} alt="" style={{marginLeft: "4px"}}/>{" "}
                  </p>
                  <p>to upgrade</p>
                </span>
              </div>
            </div>
          </div>
          {/* <PointHistory /> */}
        </div>
      )}

      <div>
        <PointHistory />
      </div>
      {failModalShow ? (
        <ConditionalModalInviteFail
          show={true}
          onHide={() => {
            setFailModalShow(false);
            setFailMessage("");
            setModalShow(false);
            handleResetOutside();
          }}
          text={failMessage}
        />
      ) : null}
      {successModalShow ? (
        <ConditionalModalInviteSucess
          show={true}
          onHide={() => {
            setSuccessModalShow(false);
            setSuccessMessage("");
            setModalShow(false);
            handleResetOutside();
          }}
          text={successMessage}
        />
      ) : null}
      {successModal2Show ? (
        <ConditionalModalBillSucess
          show={true}
          onHide={() => {
            setSuccessModal2Show(false);
            setSuccessMessage("");
            setModalShow(false);
            handleResetOutside();
          }}
          text={successMessage}
        />
      ) : null}
    </>
  );
};

export default ExclusiveProgram;
